import type { ReactElement } from 'react';
import React from 'react';

import type { IToolbarItem } from './../../ricos-types';
import { uuid } from './../../wix-rich-content-common';

// TODO: REFACTOR SO IT DOES NOT CLONE ANYMORE!
export class ToolbarButton {
  private readonly key: string;

  private readonly toolbarItem: IToolbarItem;

  private readonly toolbarItemRenderElement: ReactElement;

  constructor(toolbarItem: IToolbarItem, toolbarItemRender: ReactElement) {
    this.toolbarItem = toolbarItem;
    this.toolbarItemRenderElement = toolbarItemRender;
    this.key = uuid();
  }

  getId() {
    return this.toolbarItem.id;
  }

  getButtonElement(): ReactElement {
    return React.cloneElement(this.toolbarItemRenderElement, {
      key: this.key,
    });
  }

  getButtonElementWithDataHook(): ReactElement {
    const { dataHook = '' } = this.toolbarItem.presentation || {};
    return React.cloneElement(this.toolbarItemRenderElement, {
      key: this.key,
      dataHook,
    });
  }

  getButtonDataHook(): string {
    const { dataHook = '' } = this.toolbarItem.presentation || {};
    return dataHook;
  }
}
